export default "__VITE_ASSET__928f5835__"